const controllers = new Map();
const validators = new Map();
const eventBuses = new Map();
const renderViews = new Map();

class FormContainer {
  registerController(type, ComponentType) {
    controllers.set(type, ComponentType);
  }

  getController(type) {
    return controllers.get(type);
  }

  removeControllers() {
    controllers.clear();
  }

  removeController(type) {
    controllers.delete(type);
  }

  getRegisteredControllers() {
    const response = {};
    for (const [key, value] of controllers.entries()) {
      response[key] = value;
    }
    return response;
  }

  registerValidator(validator) {
    validators.set('global', validator);
  }

  getValidator() {
    return validators.get('global');
  }

  registerEventBus(formIndex, bus) {
    eventBuses.set(formIndex, bus);
  }

  getEventBus(formIndex) {
    return eventBuses.get(formIndex);
  }

  removeEventBus(formIndex) {
    eventBuses.delete(formIndex);
  }

  registerViewRenders(name, Component) {
    renderViews.set(name, Component);
  }

  getViewRender(name) {
    return renderViews.get(name);
  }

  removeViewRender(name) {
    return renderViews.delete(name);
  }
}

export default new FormContainer();
